<template>
  <div class="py-6 px-1 md:px-2 lg:px-6">
    <div class="mx-auto py-8 max-w-sm flex justify-center text-black">
            <span class="h-full">
                 <img src="/img/logo_vipmod.png" style="height: 50%; max-width: 50%; display: block; margin: auto;"/>
            </span>
    </div>

    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Auth',
}
</script>
